import "../../base_builders/vertical/rcp/rcp_base_builder";

import FactCheck from '../../../assets/js/FactCheck/FcApp/InitFcApp.js';
FactCheck();

clearInterval(rcp_page_refresh_interval);